/* eslint-disable no-else-return */
import React, { useEffect } from 'react';
import {
  ListItem,
  ListItemSecondaryAction,
  Divider,
  ListItemText
} from '@material-ui/core';
import { FormViewContent } from 'components/FormViewContent';
import { openPopOver, closePopOver } from 'helpers/PopOver';
import Icon from '@material-ui/core/Icon';
import { withAppContext } from '@ctsu/loader';
import { withStyles } from '@material-ui/core/styles';
import { compose, withHandlers, withState } from 'recompose';
import atoms from 'ctsutheme/components/atoms';
import { MUISelect, MUITextBox, ValidatorForm } from 'components/FormHelpers/FormInputs';
import { MUIDateTimePicker } from 'components/FormHelpers/DatePicker';
import _ from 'lodash';
import { openConfirmation } from 'helpers/Confirmation';
import {
  getUIDTFormat,
  getApiDTFormat,
  useCtxParseValue,
  GetFromCtxValue,
  getEmptyValue
} from 'helpers';
import { CTSUCardActions } from 'components';
import PropTypes from 'prop-types';
import { FasInfoCircle } from 'assets/icons';

const { Button } = atoms;

const styles = theme => ({
  formField: {
    // textIndent: 5,
    // width: 300,
    // textAlign: 'left'
  },
  iconHover: {
    fontSize: '1rem',
    marginTop: '1.5rem',
    cursor: 'pointer'
  },
  dateField: {
    width: 220,
    height: 33
  },
  btnMarginRight: {
    marginRight: 10
  }
});

function openPoper(element, msg) {
  openPopOver({
    elem: element.currentTarget.parentElement.parentElement,
    message: msg
  });
}

function getRationaleOptions(rationales) {
  if (rationales.length === 1 && rationales[0] === '0') {
    return [];
  }
  return rationales.map((opt, index) => (
    <ListItem
      key={_.uniqueId('protocol_rationales_sel')}
      button
      value={opt}
    >
      {opt}
    </ListItem>
  ));
}

getRationaleOptions.propTypes = {
  rationales: PropTypes.oneOfType([PropTypes.array])
};

getRationaleOptions.defaultProps = {
  rationales: []
};

function getReasonOptions(reasons, multiPhase, status) {
  if (!_.isEmpty(reasons) && reasons.length >= 1 && reasons[0]) {
    const reasonList = _.clone(reasons);
    if (status === 'Temporarily Closed to Accrual' && !multiPhase) {
      _.remove(reasonList, c => c === "End of Initial Phase of Multi-phase protocol");
    }
    return reasonList.map((opt, index) => (opt ? (
      <ListItem
        key={_.uniqueId('protocol_reasons_sel')}
        button
        value={opt}
      >
        {opt}
      </ListItem>
    ) : []));
  }
  return [];
}

getReasonOptions.propTypes = {
  reasons: PropTypes.oneOfType([PropTypes.array]),
  status: PropTypes.string
};

getReasonOptions.defaultProps = {
  reasons: [],
  status: ''
};

const checkDtlFlag = (dtlTemplateComplied, dtlMsg) => dtlTemplateComplied !== 'NA' && dtlTemplateComplied === 'N' ? `<li>${dtlMsg}</li>` : '';

const checkIndIdeFlag = (isIndIdeTypeComplied, indIdeMsg) => isIndIdeTypeComplied !== true ? `<li>${indIdeMsg}</li>` : '';

const checkStudyDrugFlag = (isStudyDrugSetupComplied, studyAgentMsg) => isStudyDrugSetupComplied !== true ? `<li>${studyAgentMsg}</li>` : '';

const checkApprovalIrbFlag = (cirbApprovalComplied, latestIrbApprovalDate, isIrbExempt, irbMsg) => {
  if(cirbApprovalComplied === 'N' && !isIrbExempt) {
    return (`<li>${irbMsg}</li>`);
  }
  if (cirbApprovalComplied === 'NA' && latestIrbApprovalDate === null && !isIrbExempt) {
    return (`<li>${irbMsg}</li>`);
  }
  
  return '';
};

const checkApprovalLpoFlag = (cirbApprovalComplied, latestIrbApprovalDate, isIrbExempt, lpoMsg) => {
  if(cirbApprovalComplied === 'N' && isIrbExempt) {
    return (`<li>${lpoMsg}</li>`);
  }
  if (cirbApprovalComplied === 'NA' && latestIrbApprovalDate === null && isIrbExempt) {
    return (`<li>${lpoMsg}</li>`);
  }
  return '';
};

const checkVersionFlag = (isVersionSetupComplied, versionMsg) => isVersionSetupComplied !== true ? `<li>${versionMsg}</li>` : '';

function StatusValidation(setupIndicator, valMsg, isIrbExempt) {
  const {
    dtlTemplateComplied,
    isIndIdeTypeComplied,
    isStudyDrugSetupComplied,
    cirbApprovalComplied,
    isVersionSetupComplied,
    latestIrbApprovalDate
  } = setupIndicator || {};

  const lpoMsg = 'Protocol cannot be Activated until LPO approval is received for this protocol and a site with complied LPO approval exists on the protocol. Please contact the CTSU Regulatory Office for assistance.';

  let msg = '';
  msg += checkDtlFlag(dtlTemplateComplied, valMsg.DTLFlag);
  msg += checkIndIdeFlag(isIndIdeTypeComplied, valMsg.IndIde);
  msg += checkStudyDrugFlag(isStudyDrugSetupComplied, valMsg.StudyAgents);
  msg += checkApprovalIrbFlag(cirbApprovalComplied, latestIrbApprovalDate, isIrbExempt, valMsg.InitialIRB);
  msg += checkApprovalLpoFlag(cirbApprovalComplied, latestIrbApprovalDate, isIrbExempt, lpoMsg);
  msg += checkVersionFlag(isVersionSetupComplied, valMsg.Versions);

  if (isIrbExempt) {
    const textArray = ['Protocol cannot be Activated until LPO approval is received for this protocol and a site with complied LPO approval exists on the protocol. Please contact the CTSU Regulatory Office for assistance.'];
    msg = '';
    if (cirbApprovalComplied === 'N') {
      textArray.forEach((text) => {
        msg += `<li>${text}</li>`;
      });
    }
  }
  return !_.isEmpty(msg) ? `<ul class="redMark">${msg}</ul>` : '';
}

StatusValidation.propTypes = {
  dtlTemplateComplied: PropTypes.string,
  isIndIdeTypeComplied: PropTypes.bool,
  isStudyDrugSetupComplied: PropTypes.bool,
  cirbApprovalComplied: PropTypes.string,
  isVersionSetupComplied: PropTypes.bool
};

StatusValidation.defaultProps = {
  dtlTemplateComplied: '',
  isIndIdeTypeComplied: false,
  isStudyDrugSetupComplied: false,
  cirbApprovalComplied: '',
  isVersionSetupComplied: false
};

function IsActiveCheck(el, preActiveMsg) {
  return (el === 'Active' || el === 'Pre-Activation')
    ? !_.isEmpty(preActiveMsg) : (el === 'Administratively Complete' || el === 'Approved');
}

const Reason = ({
  state, classes, reasonOptions, handleInputChange, protReasonToolTips, multiPhase
}) => (
  <FormViewContent
    primaryText="Reason"
    secondaryText={(
      <MUISelect
        withRequiredValidator
        disabled={_.isEmpty(reasonOptions)}
        className={classes.formField}
        name="statusReason"
        value={getEmptyValue(state.statusReason)}
        onChange={handleInputChange}
        validators={
          !_.isEmpty(reasonOptions) && !state.statusReason ? ['required'] : []
        }
        errorMessages={
          !_.isEmpty(reasonOptions)
          && !state.statusReason ? ['Reason is required'] : []
        }
        title={protReasonToolTips[state.rqtGrpProtStatus]}
      >
        {getReasonOptions(reasonOptions, multiPhase, getEmptyValue(state.rqtGrpProtStatus))}
      </MUISelect>
    )}
  />
);

Reason.propTypes = {
  state: PropTypes.oneOfType([PropTypes.object]),
  classes: PropTypes.oneOfType([PropTypes.object]),
  reasonOptions: PropTypes.oneOfType([PropTypes.array]),
  handleInputChange: PropTypes.func
};

Reason.defaultProps = {
  state: null,
  classes: null,
  reasonOptions: null,
  handleInputChange: null
};

const Rationale = ({
  state, classes, rationaleOptions, handleInputChange, protRationaleToolTips
}) => (
  <FormViewContent
    primaryText="Rationale"
    secondaryText={(
      <MUISelect
        withRequiredValidator
        disabled={_.isEmpty(rationaleOptions)}
        name="rationale"
        className={classes.formField}
        value={getEmptyValue(state.rationale)}
        onChange={handleInputChange}
        validators={!_.isEmpty(rationaleOptions) && !state.rationale ? ['required'] : []}
        errorMessages={
              !_.isEmpty(rationaleOptions) ? ['Rationale is required'] : []
            }
        title={protRationaleToolTips[state.rqtGrpProtStatus]}
      >
        {getRationaleOptions(rationaleOptions)}
      </MUISelect>
      )}
  />
);

Rationale.propTypes = {
  state: PropTypes.oneOfType([PropTypes.object]),
  classes: PropTypes.oneOfType([PropTypes.object]),
  rationaleOptions: PropTypes.oneOfType([PropTypes.array]),
  handleInputChange: PropTypes.func
};

Rationale.defaultProps = {
  state: null,
  classes: null,
  rationaleOptions: null,
  handleInputChange: null
};

const StatusUpdate = ({
  classes,
  state,
  setState,
  save,
  isRequestCancelable,
  statusChangeInfo,
  setupIndicator,
  grpProtStatusDate,
  grpProtStatus,
  handleInputChange,
  onCancelStatusChange,
  handleDateChange,
  savePrtStatus,
  clearStatusFields,
  closeStatusChange,
  multiPhase,
  isIrbExempt,
  nihAdminCode,
  disableStatus,
  isCirbRequired
}) => {
  const ValidationMsg = useCtxParseValue('PROTOCOL_VALIDATION_MSG');
  const ProtStatusToolTips = useCtxParseValue('PROTOCOL_STATUS_TOOLTIPS');
  const protRationaleToolTips = useCtxParseValue('PROTOCOL_RATIONALE_TOOLTIPS');
  const protReasonToolTips = useCtxParseValue('PROTOCOL_REASON_TOOLTIPS');
  const lovStatusTooltips = useCtxParseValue('LOV_STATUS_TOOLTIPS');
  const { protocolStsCanGoto } = useCtxParseValue('LOV_PROTOCOL_STATUS_GOTO');
  const { protocolStsRationale } = useCtxParseValue('LOV_PROTOCOL_STATUS_RATIONALE');
  const { protocolStsReason } = useCtxParseValue('LOV_PROTOCOL_STATUS_REASON');
  const { protocolStsRationaleReason } = useCtxParseValue(
    'LOV_PROTOCOL_STATUS_RATIONALE_REASON'
  );

  // const { latestIrbApprovalDate } = setupIndicator || {};

  const preActiveMsg = StatusValidation(setupIndicator, ValidationMsg, isIrbExempt);
  protocolStsCanGoto.push({ from_state: 'FDAAA/IRB Completed', to_state: [] });

  const allowedNewStatus = _.filter(protocolStsCanGoto, {
    from_state: grpProtStatus
  });

  useEffect(() => {
    setState({ ...statusChangeInfo });
    ValidatorForm.addValidationRule('minStatusDate', value => (
      value
        && value !== 'Invalid date'
        && grpProtStatusDate
        && value >= getUIDTFormat(grpProtStatusDate)
    ));

    // ValidatorForm.addValidationRule('minIrbDate', value => (
    //   value
    //     && value !== 'Invalid date'
    //     && grpProtStatusDate
    //     && value >= getUIDTFormat(latestIrbApprovalDate)
    // ));

    ValidatorForm.addValidationRule('isKnownWord', value => {
      const lowerValue = value.toLowerCase();
      return !(
        lowerValue.includes('interim')
        || lowerValue.includes('monitoring')
        || lowerValue.includes('drug')
        || lowerValue.includes('toxicity')
      );
    });
  }, [statusChangeInfo, grpProtStatusDate, setState]);


  const { rqtGrpProtStatus, rationale } = state;
  const allowedStatus = !_.isEmpty(allowedNewStatus) && allowedNewStatus[0].to_state;
  const prtStsRationale = _.filter(protocolStsRationale,
    (o) => JSON.parse(o.protocol_status) === rqtGrpProtStatus);
  const rationaleOptions = !_.isEmpty(prtStsRationale)
    ? JSON.parse(prtStsRationale[0].rationale)
    : [];

  let reasonOptions = [];
  const prtrationaleOptions = _.filter(protocolStsRationaleReason,
    (o) => JSON.parse(o.rationale) === rationale);
  const prtreasonOptions = _.filter(protocolStsReason,
    (o) => JSON.parse(o.protocol_status) === rqtGrpProtStatus);

  if (!_.isEmpty(prtrationaleOptions)) {
    reasonOptions = JSON.parse(prtrationaleOptions[0].reason);
  } else if (!_.isEmpty(prtreasonOptions)) {
    reasonOptions = JSON.parse(prtreasonOptions[0].reason);
  }


  const getDisabled = (item, disStatus) => {

    let included;

    included = _.includes(allowedStatus, JSON.stringify(item));

    // PROT-528. nihadmin = CTEP, cirbrequired = yes & clouser record in cirb exists. fddaa selectable
    // if(disStatus && item === 'FDAAA/IRB Completed') {
    //   included = true;
    // } 

    // PROT-528. nihadmin = CTEP, cirbrequired = yes & no clouser record in cirb exists. fddaa not selectable
    if(!disStatus && item === 'FDAAA/IRB Completed') {
      included = false;
    }

    // PROT-528. nihadmin = CTEP, cirbrequired = no
    if(nihAdminCode === 'CTEP'&& !isCirbRequired && item === 'FDAAA/IRB Completed') {
      included = true;
    }

   // PROT-528. nihadmin != CTEP, & clouser record in cirb exists. fddaa selectable
    if(nihAdminCode !== 'CTEP' && item === 'FDAAA/IRB Completed') {
      included = true;
    }

    return included ? IsActiveCheck(item, preActiveMsg) : !included;
  };

  return (
    <ValidatorForm onSubmit={savePrtStatus}>
      <FormViewContent
        primaryText="Requested Status"
        secondaryText={(
          <MUISelect
            className={classes.formField}
            validators={['required']}
            errorMessages={['Protocol Status is required']}
            title={ProtStatusToolTips[state.rqtGrpProtStatus]}
            value={getEmptyValue(state.rqtGrpProtStatus)}
            onChange={handleInputChange}
            name="rqtGrpProtStatus"
          >
            {_.map(protocolStsCanGoto, 'from_state').map((item, i) => !['In Review', 'Administratively Complete'].includes(item)
            && (
              <ListItem
                key={_.uniqueId('protocol_status_goto_sel')}
                button
                divider={i + 1 < protocolStsCanGoto.length}
                disabled={ getDisabled(item, disableStatus)}
                value={item}
              >
                <ListItemText
                  primary={item}
                  secondary={lovStatusTooltips[item]}
                />
                {(item === 'Active' || item === 'Pre-Activation') && (
                  !_.isEmpty(preActiveMsg) && _.includes(allowedStatus, item) && (
                  <ListItemSecondaryAction>
                    <Icon
                      onMouseEnter={props => openPoper(
                        props,
                        preActiveMsg
                      )}
                      onMouseLeave={() => closePopOver()}
                      className={classes.iconHover}
                      title="Validation Error"
                      color="error"
                    >
                      <FasInfoCircle />
                    </Icon>
                  </ListItemSecondaryAction>
                  )
                )}
                {(item === 'Administratively Complete' || item === 'Approved') && (
                <ListItemSecondaryAction>
                  <Icon
                    onMouseEnter={props => openPoper(
                      props,
                      `To change status to ${item}, Please Contact PIO.`
                    )}
                    onMouseLeave={() => closePopOver()}
                    className={classes.iconHover}
                    title="Validation Error"
                    color="error"
                  >
                    <FasInfoCircle />
                  </Icon>
                </ListItemSecondaryAction>
                )}
              </ListItem>
            ))}
          </MUISelect>
        )}
      />
      <Divider />
      <FormViewContent
        className="MuiListItem-react-datepicker react-datepicker-time-fix"
        primaryText="Status Date & Time (ET)"
        secondaryText={(
          <MUIDateTimePicker
            title="Status Date & Time (ET)"
            withRequiredValidator
            id="rqtGrpProtStatusDate"
            name="rqtGrpProtStatusDate"
            className={classes.dateField}
            validators={['required', 'minStatusDate']}
            errorMessages={[
              'Status Date & Time is Required', `Should be later than or equal to ${grpProtStatusDate}`]}
            value={
              state.rqtGrpProtStatusDate
                ? getUIDTFormat(state.rqtGrpProtStatusDate)
                : ''
            }
            onChange={handleDateChange('rqtGrpProtStatusDate')}
          />
        )}
      />
      <Divider />
      {isRequestCancelable && (
        <>
          <Button
            size="medium"
            variant="outlined"
            color="primary"
            data-id="cancelReq"
            onClick={onCancelStatusChange}
            style={{ margin: '1rem 0 1.5rem' }}
            className="turquoise"
          >
            Cancel Request
          </Button>
          <Divider />
        </>
      )}
      <Rationale
        state={state}
        classes={classes}
        rationaleOptions={rationaleOptions}
        handleInputChange={handleInputChange}
        protRationaleToolTips={protRationaleToolTips}
      />
      <Divider />
      <Reason
        state={state}
        classes={classes}
        reasonOptions={reasonOptions}
        handleInputChange={handleInputChange}
        protReasonToolTips={protReasonToolTips}
        multiPhase={multiPhase}
      />
      <Divider />
      <FormViewContent
        primaryText="Other Specify"
        secondaryText={(
          <MUITextBox
            title="Other Specify"
            disabled={state.statusReason !== 'Other'}
            validators={
              state.statusReason === 'Other' ? [
                'required',
                'maxStringLength:50',
                'isKnownWord'
              ] : []
            }
            errorMessages={
              state.statusReason === 'Other' ? [
                'Other Specify is required',
                'Max characters allowed 50',
                'Please use appropriate term when a pre-defined term matches'
              ] : []
            }
            value={getEmptyValue(state.otherSpecify)}
            className={classes.formField}
            onChange={handleInputChange}
            id="outlined-other"
            name="otherSpecify"
          />
        )}
      />
      <Divider />
      <FormViewContent
        primaryText="PIO Comments"
        name="pioRequestComments"
        secondaryText={getEmptyValue(state.pioRequestComments)}
      />
      <Divider />
      <CTSUCardActions
        clearClick={clearStatusFields}
        cancelClick={closeStatusChange}
        disabled={_.isEqual(state, statusChangeInfo) || save}
        save={save}
      />
    </ValidatorForm>
  );
};

StatusUpdate.propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]),
  isRequestCancelable: PropTypes.bool,
  statusChangeInfo: PropTypes.oneOfType([PropTypes.object]),
  setupIndicator: PropTypes.oneOfType([PropTypes.object]),
  grpProtStatusDate: PropTypes.string,
  grpProtStatus: PropTypes.string,
  handleInputChange: PropTypes.func,
  onCancelStatusChange: PropTypes.func,
  handleDateChange: PropTypes.func,
  savePrtStatus: PropTypes.func,
  clearStatusFields: PropTypes.func,
  closeStatusChange: PropTypes.func
};

StatusUpdate.defaultProps = {
  classes: null,
  isRequestCancelable: false,
  statusChangeInfo: null,
  setupIndicator: null,
  grpProtStatusDate: '',
  grpProtStatus: '',
  handleInputChange: null,
  onCancelStatusChange: null,
  handleDateChange: null,
  savePrtStatus: null,
  clearStatusFields: null,
  closeStatusChange: null
};

const prtStatusUpdate = withStyles(styles)(
  compose(
    withState('state', 'setState', {}),
    withHandlers({
      clearStatusFields: props => event => {
        const { setState, statusChangeInfo } = props;
        setState({ ...statusChangeInfo });
      },
      handleInputChange: props => event => {
        const { state, setState, completionDates } = props;
        const { actualPrimaryComplDate, anticipatedPrimaryComplDate } = completionDates;
        let reqState = { ...state };
        if (event.target.name === 'rqtGrpProtStatus') {
          reqState = {};
          const onActionCall = () => {}
          if(event.target.value === 'Closed to Accrual & Treatment' && !anticipatedPrimaryComplDate ){
            openConfirmation({
              title: 'Information',
              message: 'Please update the Anticipated Primary Completion Date as needed.',
              onAction: onActionCall,
              name: 'info'
            });
          }
          
          if(event.target.value === 'Complete' && !actualPrimaryComplDate) {
            openConfirmation({
              title: 'Information',
              message: `The Primary Completion Date (PCD) should be set when setting a study status to ${event.target.value}.`,
              onAction: onActionCall,
              name: 'pcd_date_check'
            });
          }
        }
        if (event.target.name === 'rationale') {
          reqState.statusReason = null;
        }
        reqState[event.target.name] = event.target.value ? event.target.value : '';
        setState({ ...reqState });
      },
      handleDateChange: props => name => event => {
        const { state, setState } = props;
        state[name] = event ? getApiDTFormat(event) : '';
        setState({ ...state });
      },
      savePrtStatus: props => event => {
        const {
          state, context, onSaveStatusChange, setSave, setupIndicator, grpProtStatus, completionDates
        } = props;

        const { actualPrimaryComplDate } = completionDates;
        if(state.rqtGrpProtStatus === 'FDAAA/IRB Completed' && !actualPrimaryComplDate) {
          openConfirmation({
            title: 'Information',
            message: `Please set the Primary Completion Date prior to changing the study status to FDAAA/IRB Complete status.`,
            onAction: () => {},
            name: 'pcd_date_check'
          });
          return;
        }

        const confirmSave = () => {
          setSave();
          onSaveStatusChange({
            ...state
          });
        };
        const preActiveMsg = state.rqtGrpProtStatus === 'Pre-Activation'
        && (setupIndicator && setupIndicator.dtlTemplateComplied === 'Y'
        && setupIndicator.dtlTemplateStatus === 'Approved') ? '<br /><span style="font-weight:700">Note:</span>&nbsp;Pre-Activating the protocol will automatically activate the DTL template currently in approved status for this protocol' : '';

        if (state.rqtGrpProtStatus === 'Active' && (grpProtStatus === 'Pre-Activation' || grpProtStatus === 'Approved')) {
          openConfirmation({
            title: 'Attestation',
            type: 'ATTEST',
            message: GetFromCtxValue(context, 'PROTOCOL_STATUS_ACTIVE_ATTESTATION'),
            onAction: confirmSave,
              name: 'attestation'
          });
        } else {
          openConfirmation({
            message: GetFromCtxValue(context, 'PROTOCOL_STATUS_CHANGE_CONFIRM') + preActiveMsg,
            onAction: confirmSave,
              name: 'status_change'
          });
        }
      }
    })
  )(StatusUpdate)
);

const EditStatusChange = withAppContext(prtStatusUpdate);

export { EditStatusChange };
